import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

/**
 * /book — Get Started page.
 *
 * Loads Otto's Calendly inline. All scheduling, package selection, and
 * confirmations are handled by Calendly + Otto's Google Calendar — we do
 * nothing on our side here besides hosting the embed.
 *
 * Calendly account: thiel-fitfusionanalytics
 */
const CALENDLY_URL = "https://calendly.com/thiel-fitfusionanalytics";

export default function BookConsultationPage() {
  // Load Calendly's official inline-embed script once on mount. It auto-resizes
  // the iframe to fit content and gives us a nicer mobile experience than a
  // raw <iframe>.
  useEffect(() => {
    const SRC = "https://assets.calendly.com/assets/external/widget.js";
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="book-page">
      <Navbar />

      <section className="pt-28 pb-10 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6" data-testid="book-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#007AFF] mb-3">GET STARTED</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-black mb-4 leading-[1.1]">
          Book your session with Otto
        </h1>
        <p className="text-muted-foreground max-w-2xl leading-relaxed">
          Pick the program and time that fits you best. Bookings sync directly to Otto's calendar — you'll get a confirmation email the moment you reserve your spot.
        </p>
      </section>

      <section className="px-2 sm:px-6 md:px-12 lg:px-24 max-w-6xl mx-auto pb-24">
        <div
          className="calendly-inline-widget bg-card border border-border"
          data-url={`${CALENDLY_URL}?hide_landing_page_details=0&hide_gdpr_banner=1`}
          style={{ minWidth: "320px", height: "1050px" }}
          data-testid="calendly-embed"
        />

        {/* Tiny fallback link in case JS / network blocks the embed (rare). */}
        <noscript>
          <div className="text-center py-12">
            <p className="text-sm text-muted-foreground mb-4">
              The booking widget couldn't load. You can still book directly on Calendly:
            </p>
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#007AFF] hover:bg-[#3395FF] text-white rounded-none px-8 py-5 font-bold tracking-wide">
                Open Calendly
              </Button>
            </a>
          </div>
        </noscript>
      </section>

      <Footer />
    </div>
  );
}
